import { REDUCER_KEY } from "./enabledAccount.constants";
export var getEnabledAccounts = function (state) {
    return state[REDUCER_KEY].enabledAccounts;
};
export var isFetchingEnabledAccounts = function (state) {
    return state[REDUCER_KEY].isFetchingEnabledAccounts || false;
};
export var fetchEnabledAccountsError = function (state) {
    return state[REDUCER_KEY].fetchEnabledAccountsError;
};
export var getEnabledAccountsCount = function (state) {
    return state[REDUCER_KEY].enabledAccountsCount;
};
export var isFetchingEnabledAccountsCount = function (state) {
    return state[REDUCER_KEY].isFetchingEnabledAccountsCount || false;
};
export var fetchEnabledAccountsCountError = function (state) {
    return state[REDUCER_KEY].fetchEnabledAccountsCountError;
};
export var isAdding = function (state) {
    return state[REDUCER_KEY].isAdding || false;
};
export var addError = function (state) {
    return state[REDUCER_KEY].addError;
};
export var isRemoving = function (state) {
    return state[REDUCER_KEY].isRemoving || false;
};
export var removeError = function (state) {
    return state[REDUCER_KEY].removeError;
};
export var isUsing = function (state) {
    return state[REDUCER_KEY].isUsing || false;
};
export var useError = function (state) {
    return state[REDUCER_KEY].useError;
};
